/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Edit_BtnInputs */



/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Developer_Edit_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_edit_btn = /** @type {((inputs?: Developer_Edit_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Edit_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Editar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica")
	return /** @type {LocalizedString} */ ("Edit")
});